import React, { useEffect, useState } from "react";
import { Typography, Button } from "@material-ui/core";
import useStyles from "./styles";

export default function ModalError({
  open,
  onClose,
  title,
  children,
  primaryButton,
  secondaryButton,
}) {
  const classes = useStyles();
  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      setAnimationKey((prev) => prev + 1);
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [open]);

  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const hasButtons = primaryButton || secondaryButton;

  return (
    <>
      <div
        onClick={handleBackdropClick}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1299,
          animation: "fadeIn 0.3s ease-out",
        }}
      />

      <div key={animationKey} className={classes.container}>
        <div className={classes.header}>
          <Typography
            style={{
              fontWeight: 700,
              fontSize: "clamp(16.5px, 2vw, 24px)",
              color: "#333333",
              flex: 1,
              textAlign: "center",
            }}
          >
            {title}
          </Typography>
        </div>

        <div className={classes.content}>{children}</div>

        {hasButtons && (
          <div className={classes.buttons}>
            {secondaryButton && (
              <Button
                className={classes.secondaryButton}
                style={{ marginBottom: 10 }}
                onClick={secondaryButton.onClick}
              >
                {secondaryButton.label}
              </Button>
            )}
            {primaryButton && (
              <Button
                className={classes.primaryButton}
                onClick={primaryButton.onClick}
              >
                {primaryButton.label}
              </Button>
            )}
          </div>
        )}
      </div>

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}
      </style>
    </>
  );
}
